"use strict";
/*
* Created on 23.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var index_1 = require("../../core/utils/index");

var Stockout_1 = require("../model/Stockout");

var StockoutConverter_1 = require("./StockoutConverter");
/**
 * Implementation of {@link StockoutConverter}.
 * @author ZSr
 */


var StockoutConverterImpl =
/*#__PURE__*/
function (_StockoutConverter_1$) {
  _inherits(StockoutConverterImpl, _StockoutConverter_1$);

  function StockoutConverterImpl() {
    _classCallCheck(this, StockoutConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(StockoutConverterImpl).apply(this, arguments));
  }

  _createClass(StockoutConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Stockout_1.Stockout(Stockout_1.Stockout.schema.id.valueOf(conversions.documentToClassId(source)), Stockout_1.Stockout.schema.externalId.valueOfField(source), Stockout_1.Stockout.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), Stockout_1.Stockout.schema.promotionId.valueOf(index_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toClassReferenceId(source.promotionId)), Stockout_1.Stockout.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), Stockout_1.Stockout.schema.dateOfStockout.valueOfField(source), Stockout_1.Stockout.schema.amount.valueOf(conversions.toBigNumber(source.amount)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        promotionId: index_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toDocumentReferenceId(source.promotionId),
        productId: conversions.toDocumentReferenceId(source.productId),
        dateOfStockout: conversions.fromDate(source.dateOfStockout),
        amount: conversions.fromBigNumber(source.amount),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return StockoutConverterImpl;
}(StockoutConverter_1.StockoutConverter);

exports.StockoutConverterImpl = StockoutConverterImpl;